import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

import { Input } from '../../../components/ui/input.tsx';
import { Button } from '../../../components/ui/button.tsx';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card.tsx';
import { Laptop, Smartphone, Tablet } from 'lucide-react';
import ChangeEmailModal from '../../../components/dashboard/ChangeEmail.jsx';
import useAuth from '../../../hooks/useAuth.js';

const Security = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const devices = [
    {
      id: '1',
      type: 'Laptop',
      os: 'Windows',
      browser: 'Google Chrome',
      when: '',
      location: 'Lagos, Nigeria',
      current: true,
    },
    {
      id: '2',
      type: 'Phone',
      os: 'Android',
      browser: 'Google Chrome',
      when: 'Aug 21, 2023',
      location: 'Lagos, Nigeria',
    },
    {
      id: '3',
      type: 'Tablet',
      os: 'iOS',
      browser: 'Safari',
      when: 'Jul 5 2023',
      location: 'Lagos, Nigeria',
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
      }}
    >
      <p className="text-xl mb-4">{state?.label || 'Security Settings'}</p>
      <div className="space-y-6">
        {/* Email Card */}
        <Card>
          <CardHeader>
            <CardTitle>Email</CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between">
            <Input
              type="email"
              value={user?.email || ''}
              disabled
              className="flex-1 mr-4 bg-gray-100"
            />
            <Button size="sm" onClick={() => setIsModalOpen(true)}>
              Edit Email
            </Button>
          </CardContent>
        </Card>

        {/* Password Card */}
        <Card>
          <CardHeader>
            <CardTitle>Password</CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between">
            <Input
              type="password"
              value="••••••••"
              disabled
              className="flex-1 mr-4 bg-gray-100"
            />
            <Button size="sm" onClick={() => navigate('/forgot-password')}>
              Change Password
            </Button>
          </CardContent>
        </Card>

        {/* Logged-In Devices Card */}
        <Card>
          <CardHeader>
            <CardTitle>Logged in Devices</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {devices.map((d) => {
              let Icon = Laptop;
              if (d.type === 'Phone') Icon = Smartphone;
              if (d.type === 'Tablet') Icon = Tablet;

              return (
                <div key={d.id} className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <Icon className="h-6 w-6 text-gray-600" />
                    <div>
                      <p className="font-medium text-gray-900">{d.type}</p>
                      <p className="text-sm text-gray-500">
                        {d.os} • {d.browser}
                      </p>
                    </div>
                  </div>
                  <div className="text-right text-sm text-gray-600 space-y-0.5">
                    {d.current ? (
                      <span className="inline-block px-2 py-0.5 bg-gray-200 rounded-full text-xs">
                        Current
                      </span>
                    ) : (
                      <div>{d.when}</div>
                    )}
                    <div>{d.location}</div>
                  </div>
                </div>
              );
            })}
          </CardContent>
        </Card>
      </div>

      {/* Modal for changing email */}
      <ChangeEmailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentEmail={user.email}
      />
    </motion.div>
  );
};

export default Security;
